export default {
  query: '',
  visibleTagsId: [],
  activeParentTagId: null,
  selectedVariantIndex: null,
};
